        
@if(context === 'taskbook' && taskActions){  
    <div class="d-flex flex-column pt-4 justify-content-end h-100">
        @for(actionItem of taskActions; track actionItem.id){
            <button class="btn px-2 mb-1 d-flex align-items-center action-item" [ngClass]="actionItem.class" (click)="action(task, actionItem)">
                <div class="action-item-icon">
                    <i class="fa-regular" [ngClass]="actionItem.icon"></i>
                </div>
                <div class="action-item-content text-start px-2">
                    <span class="action-item-title">{{actionItem.label.title | translate }}</span>
                    @if(actionItem.label.description ){ 
                        <span class="action-item-desc">{{actionItem.label.description | translate }}</span>
                    }
                </div>
            </button>
        }
    </div>
}

@if(context === 'task-success-dialog' && taskActions){  
    <div class="task-success-dialog d-flex flex-column justify-content-center align-items-center pt-2">
        <button class="btn btn-continue action-item" (click)="action(task, null)">
            <i class="fa-regular fa-magnifying-glass pe-2"></i>{{ 'task_action.continue' | translate }}
        </button>  
        @for(actionItem of taskActions; track actionItem.id){
            @if(actionItem.id === 'archive'){
                <hr class="border w-75 my-2">
                <button class="btn btn-archive action-item" [ngClass]="actionItem.class" (click)="action(task, actionItem)">
                    <i class="fa-regular pe-2" [ngClass]="actionItem.icon"></i>{{actionItem.label.title | translate }}
                </button>
            }
        }
    </div>
}


